import clsx from "clsx";
import styles from "./styled.module.scss";

interface UndertypeSelectorProps extends React.HTMLAttributes<HTMLDivElement> {
  list: string[];
  selected: string;
  onSelectType: (value: string) => void;
}

function UndertypeSelector({
  list,
  onSelectType,
  selected,
  className,
  ...props
}: UndertypeSelectorProps) {
  return (
    <div className={clsx(styles.typesList, className)} {...props}>
      {list.map((type) => (
        <div
          key={type}
          className={clsx(styles.typeContainer, {
            [styles.active]: type === selected,
          })}
        >
          <span className={styles.type} onClick={() => onSelectType(type)}>
            {type}
          </span>
          <div className={styles.underline} />
        </div>
      ))}
    </div>
  );
}

export default UndertypeSelector;
